import React from 'react';
import cn from 'classnames';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

import { connect } from '../../../StateProvider';
import SCENE_CONTAINER from '../../../../configs/sceneContainer';
import SCENE_TYPE from '../../../../configs/sceneTypes';
import ModalSceneContainer from './ModalSceneContainer';
import Base from '../index';
import ScenesList from './ScenesList';
import sceneActions from '../../../../actions/sceneActions';

import styles from './multiModal.less';
import Icon from '../../UI/Icon';

class MultiModal extends React.PureComponent {
  state = {};

  onCloseModal = () => {
    sceneActions.setVisible(false);
  };

  onClose = (sceneId) => {
    sceneActions.closeScene(sceneId);
  };

  switchModal = (sceneId) => {
    sceneActions.switchModal(sceneId);
  };

  getScenePath = () => {
    const { scenes, catalogs, activeSceneId, t } = this.props;

    let title = "";
    let titlePath = [];
    const split = (<span className={styles.breadSplit}>→</span>);

    let current = scenes.find(scene => scene.get('sceneId') === activeSceneId);
    if (!current) return "";

    let fieldId;
    let relationId;
    let prevCatalogId;
    
    while (current) {
      // get title
      const sceneId = current.get("sceneId");
      const params = current.get("params");

      const catalogId = params ? params.get("catalogId") : null;
      const recordId = params ? params.get("recordId") : null;

      const catalog = catalogId && catalogs && catalogs.get(catalogId);

      if ( catalog ) {
        const catalogIcon = catalog.get("icon");

        if ( recordId && fieldId ) {
          // opened from field
          const fields = catalog.get("fields");
          const field = fields.find(f=> f.get("id") === fieldId );
          
          // record & field title
          title = (
            <span className={styles.bread} onClick={()=>this.switchModal(sceneId)}>
              <Icon type={`anticon anticon-icon ${  catalogIcon}`} className={styles.breadIcon}/>
              <span className={styles.breadMain}>{current.get("title")}</span>
              <span className={styles.breadSub}>{field && field.get("name")}</span>
            </span>
          );
          // title = catalog.get("name") + " / " + parentScene.get("title");
          titlePath.push(title);

        } else if ( recordId && relationId ) {

          const relationCatalogId = prevCatalogId;
          const relationCatalog = relationCatalogId && catalogs && catalogs.get(relationCatalogId);

          // opened from field
          const fields = relationCatalog.get("fields");
          const field = fields.find(f=> f.get("id") === relationId );
          
          // make relation title
          // "RelationCatalog.RelationField"
          /*
          let subTitle = [relationCatalog.get("name")];
          if ( field && field.get("name") ) {
            subTitle.push(field.get("name"))
            // field & catalog can have the same name
            subTitle = _.uniq(subTitle);
            subTitle = _.join(subTitle, ": ");
          }
          */
          // "Links: RelationCatalog"
          let subTitle = `${t("record.tabs.links")  }: ${  relationCatalog.get("name")}`;

          // record & field title
          title = (
            <span className={styles.bread} onClick={()=>this.switchModal(sceneId)}>
              <Icon type={`anticon anticon-icon ${  catalogIcon}`} className={styles.breadIcon}/>
              <span className={styles.breadMain}>{current.get("title")}</span>
              <span className={styles.breadSub}>{subTitle}</span>
            </span>
          );
          // title = catalog.get("name") + " / " + parentScene.get("title");
          titlePath.push(title);

        } else if ( recordId && current.get("title") ) { // record
          // record title
          title = (
            <span className={styles.bread} onClick={()=>this.switchModal(sceneId)}>
              <Icon type={`anticon anticon-icon ${  catalogIcon}`} className={styles.breadIcon}/>
              <span className={styles.breadMain}>{current.get("title")}</span>
            </span>
          );
          titlePath.push(title);
        } else if ( recordId && ! current.get("title") ) { // new record
          // catalog * title
          title = (
            <span className={styles.bread} onClick={()=>this.switchModal(sceneId)}>
              <Icon type={`anticon anticon-icon ${  catalogIcon}`} className={styles.breadIcon}/>
              <span className={styles.breadMain}>{catalog.get("name")} *</span>
            </span>
          );
          titlePath.push(title);
        } else { // catalog
          title = (
            <span className={styles.bread} onClick={()=>this.switchModal(sceneId)}>
              <Icon type={`anticon anticon-icon ${  catalogIcon}`} className={styles.breadIcon}/>
              <span className={styles.breadMain}>{catalog.get("name")}</span>
            </span>
          );
          titlePath.push(title);
        }
      }

      // get parent scene
      const parent = current.getIn(["params", "parent"]);
      const parentSceneId = current.get("parentSceneId");
      const parentScene = parentSceneId && scenes.find(scene => scene.get('sceneId') === parentSceneId);
      
      // need for next step
      fieldId = parent ? parent.get("fieldId") : null;
      relationId = parent ? parent.get("relationId") : null;
      prevCatalogId = catalogId;

      if ( parentScene ) {titlePath.push(split)};
      current = parentScene;
    }

    // create breadcrambs
    titlePath = _.reverse(titlePath);
    return titlePath;
  }

  setScenePath = () => {
    this.setState({title: this.getScenePath()})
  }

  componentDidMount() {
    this.setScenePath();
  }

  componentDidUpdate(prevProps) {
    const {activeScene, activeSceneId, scenes, visible, isWebForm } = this.props;
    if ( activeScene && visible && ! isWebForm ) {
      document.body.classList.add("bpium_popup_opened");
    } else {
      document.body.classList.remove("bpium_popup_opened");
    }    

    const prevActiveSceneId = prevProps.activeSceneId;
    const prevScenes = prevProps.scenes
    const prevVisible = prevProps.visible
    if ( visible && (
      visible != prevVisible
      || activeSceneId != prevActiveSceneId
      || scenes != prevScenes
     ) ) {
      this.setScenePath();
    }
  }

  render() {
    const { visible, modalScenes, activeScene, activeSceneId, initialSceneId, isWebForm } = this.props;
    const {title} = this.state;

    if (!activeScene) {
      return null;
    }

    if (!visible) {
      return null;
    }
    
    return (
      <Base
        visible={visible}
        width="100%"
        className={styles.container}
        wrapClassName={isWebForm ? styles.inWebForm: null}
        onCancel={this.onCloseModal}
        
      >
        {!isWebForm && (
          <div className={cn(styles.list)}>
            <ScenesList
              switchModal={this.switchModal}
              onClose={this.onClose}
              onCloseModal={this.onCloseModal}
              modalScenes={modalScenes}
              activeSceneId={activeSceneId}
              initialSceneId={initialSceneId}
            />
          </div>
        )}
        <div className={styles.body}>
          <div className={styles.header}>{title}</div>
          {modalScenes
            ? modalScenes.valueSeq().map((scene) => {
                const sceneId = scene.get('sceneId');
                const isActive = sceneId === activeSceneId;
                return (
                  <ModalSceneContainer
                    key={sceneId}
                    onClose={this.onClose}
                    isActive={isActive}
                    sceneId={sceneId}
                    isWebForm={isWebForm}
                  />
                );
              })
            : null}
        </div>
      </Base>
    );
  }
}

export default connect(
  withTranslation()(MultiModal),
  {
    activeSceneId: ['modal', 'activeScene'],
    visible: ['modal', 'visible'],
    scenes: ['scenes'],
    catalogs: ['catalogs'],
  },
  (props, { activeSceneId, visible, scenes, catalogs }) => {
    const modalScenes = scenes && scenes.filter((scene) => scene && scene.get('container') === SCENE_CONTAINER.POPUP);
    const initialScene =
      modalScenes &&
      modalScenes.find((scene) => {
        const parentSceneId = scene.get('parentSceneId');
        const parentSceneContainer = scenes.getIn([parentSceneId, 'container']);
        return parentSceneContainer !== SCENE_CONTAINER.POPUP;
      });
    const initialSceneId = initialScene && initialScene.get('sceneId');
    const shouldClose = initialScene && initialScene.get('shouldClose');
    const activeScene = modalScenes && modalScenes.get(activeSceneId);
    return {
      ...props,
      visible,
      activeScene,
      activeSceneId,
      modalScenes,
      scenes,
      catalogs,
      initialSceneId,
      shouldClose,
    };
  },
);
